import React from 'react'
import { Modal, Button, Row, Col, Typography, theme } from 'antd'
import { EditOutlined, CloseOutlined } from '@ant-design/icons'
import { formatDateTime, getUrgencyTag, getStatusBadge } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Title, Paragraph } = Typography

const SurgeryDetailsModal = ({ showDetailsFor, handleCloseDetails }) => {
  const { token } = theme.useToken()

  if (!showDetailsFor) return null

  return (
    <Modal
      title={`Surgery Details: ${showDetailsFor.surgeryType}`}
      visible={!!showDetailsFor}
      onCancel={handleCloseDetails}
      footer={[
        <Button
          key='close'
          onClick={handleCloseDetails}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Close
        </Button>,
        <Button
          key='edit'
          icon={<EditOutlined style={{ color: token.colorPrimary }} />}
          style={{
            background: hexToRGBA(token.colorPrimary, 0.1),
            borderColor: token.colorPrimary,
            color: token.colorPrimary,
            fontWeight: 'bold'
          }}
        >
          Edit
        </Button>
      ]}
      width={700}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Title level={5}>Patient Information</Title>
          <Paragraph>
            <strong>Name:</strong> {showDetailsFor.patientName}
          </Paragraph>
          <Paragraph>
            <strong>ID:</strong> {showDetailsFor.patientId}
          </Paragraph>
          <Paragraph>
            <strong>Status:</strong> {showDetailsFor.patientStatus}
          </Paragraph>
          <Paragraph>
            <strong>Consent:</strong> {showDetailsFor.consentStatus}
          </Paragraph>
        </Col>

        <Col span={12}>
          <Title level={5}>Surgery Information</Title>
          <Paragraph>
            <strong>Surgery ID:</strong> {showDetailsFor.surgeryId}
          </Paragraph>
          <Paragraph>
            <strong>Scheduled:</strong> {formatDateTime(showDetailsFor.scheduledDateTime)}
          </Paragraph>
          <Paragraph>
            <strong>Duration:</strong> {showDetailsFor.duration} minutes
          </Paragraph>
          <Paragraph>
            <strong>Urgency:</strong> {getUrgencyTag(showDetailsFor.urgency)}
          </Paragraph>
          <Paragraph>
            <strong>Status:</strong> {getStatusBadge(showDetailsFor.preOpStatus)}
          </Paragraph>
        </Col>

        <Col span={24}>
          <Title level={5}>Surgical Team</Title>
          <Row gutter={[16, 8]}>
            <Col span={8}>
              <Paragraph>
                <strong>Surgeon:</strong> {showDetailsFor.assignedSurgeon}
              </Paragraph>
            </Col>
            <Col span={8}>
              <Paragraph>
                <strong>Anaesthesiologist:</strong> {showDetailsFor.anaesthesiologist}
              </Paragraph>
            </Col>
            <Col span={8}>
              <Paragraph>
                <strong>Assistant:</strong> {showDetailsFor.surgicalAssistant || '-'}
              </Paragraph>
            </Col>
          </Row>
          <Paragraph>
            <strong>Nurses:</strong> {showDetailsFor.nurses?.join(', ') || '-'}
          </Paragraph>
        </Col>

        <Col span={24}>
          <Title level={5}>Pre-operative Details</Title>
          <Paragraph>
            <strong>Theatre:</strong> {showDetailsFor.surgeryRoom}
          </Paragraph>
          <Paragraph>
            <strong>Lab Results:</strong> {showDetailsFor.labResults}
          </Paragraph>
          <Paragraph>
            <strong>Special Equipment:</strong> {showDetailsFor.specialEquipment?.join(', ') || '-'}
          </Paragraph>
          <Paragraph>
            <strong>Estimated Blood Loss:</strong> {showDetailsFor.estimatedBloodLoss}
          </Paragraph>
          <Paragraph>
            <strong>Procedure Code:</strong> {showDetailsFor.procedureCode}
          </Paragraph>
        </Col>

        <Col span={24}>
          <Title level={5}>Notes</Title>
          <Paragraph>{showDetailsFor.preparationNotes || 'No special notes'}</Paragraph>
        </Col>
      </Row>
    </Modal>
  )
}

export default SurgeryDetailsModal
